module.exports = __webpack_public_path__ + "static/thumbnail-c0dcce55bd71de17d7d583fa61099b17.png";